import Swal from "sweetalert2";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { WarningTriangleOutline } from "iconoir-react";
import { domain } from "../../../Urls/Services/Api_urls";
import { showTvCompatibilityModal } from "../../../service/tvCompatibilityMessage";

export const SolicitudLoginUny = (props) => {
  const isTvCard = Boolean(props?.isTvCard);
  const estrato = window.sessionStorage.getItem("estrato");
  const CITI = window.sessionStorage.getItem("city_owner");
  const cdo = window.sessionStorage.getItem("cdo");
  const zone = window.sessionStorage.getItem("zone");
  const adress = window.sessionStorage.getItem("direction");
  const email = window.sessionStorage.getItem("emailRes");
  const cedula = window.sessionStorage.getItem("cedulaRes");
  const celular = window.sessionStorage.getItem("phoneRes");
  const name = window.sessionStorage.getItem("namedasRes");
  // const phone_fijo = window.sessionStorage.getItem("phoneRes");
  const last_name = window.sessionStorage.getItem("last_nameRes");
  const localization = window.sessionStorage.getItem("localization");

  const token = window.sessionStorage.getItem("token");
  console.log(props);
  const precio = props.precio_persona;
  let mess = "";
  var today = new Date();
  var year = today.getFullYear();
  let password = `Emcali${year}*`;
  let valor_plan = "";
  let tarifa_plena = "";
  if (props.descuento != null) {
    valor_plan = parseInt(props.descuento_valor[props.estrato]);
    //tarifa_plena = props.json_valor.residencial[estrato];
    tarifa_plena = props.json_valor && props.json_valor.residencial ? props.json_valor.residencial[props.estrato] : props.precio_persona[props.estrato];
  } else {
    valor_plan = parseInt(precio[props.estrato]);
  }

  let observacionesTexto = "";

  const meses = props.meses ?? props.months ?? null;
  const discountMonths = props.discount_months ?? null;

  if (props.descuento) {
    const hasMegas = props.megas && props.megas !== 0;
    const megasText = hasMegas ? ` y ${props.megas} MB adicionales` : '';

    if (discountMonths && meses && discountMonths !== meses) {
      observacionesTexto = `Aplica ${props.descuento}% de descuento por ${meses} meses${megasText}\npor ${discountMonths} meses. Posteriormente, se aplicará la tarifa plena vigente de ${new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(Math.trunc(tarifa_plena))} y las megas contratadas.`;
    } else {
      const mesesText = meses ? ` por ${meses} meses` : '';
      observacionesTexto = `Aplica ${props.descuento}% de descuento${megasText}${mesesText}.\nPosteriormente, se aplicará la tarifa plena vigente de ${new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(Math.trunc(tarifa_plena))}.`;
    }
  } else {
    observacionesTexto = "No aplica descuento.";
  }
  
  const warningIcon = renderToStaticMarkup(
    <WarningTriangleOutline width={16} height={16} style={{ color: "#d97706", flexShrink: 0 }} />
  );

  const campoArchivo = (inputId) => `
        <style>.btn-archivo{background-color:#e9ecef;color:#212529;border:1px solid #ced4da;border-radius:.375rem 0 0 .375rem;}.btn-archivo:hover:not(:disabled){background-color:#d3d9df;color:#212529;}.btn-archivo:focus-visible,.btn-archivo:active{background-color:#e9ecef;color:#212529;border-color:#ced4da;}</style>
        <input id="${inputId}" type="file" style="display:none">
        <div class="input-group">
            <button type="button" class="btn btn-archivo" id="${inputId}-cargar">Cargar archivo</button>
            <div class="form-control" id="${inputId}-nombre" style="text-align:left; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                <span style="color:#6c757d">Seleccionar archivo</span>
            </div>
        </div>`;

  const showSolicitudServicioModal = () => {
    Swal.fire({
    title: "Solicitar Servicio",
    html:
      `
                <form>
                <div class="m-3">
                    <div class="row mb-3">
                    <div class="col-6 mb-3">
                    <label for="NameLabelUpdate" class="labelFount">Propietario Nombre</label>
                    <input type="text" id="swal-input1" class="form-control" placeholder="Propietario" value="` +
      name +
      `">
                </div>
                <div class="col-6 mb-3">
                      <label for="NameLabelUpdate" class="labelFount">Propietario Apellido</label>
                      <input type="text" id="swal-input10" class="form-control" placeholder="Propietario" value="` +
      last_name +
      `">
                  </div>
            
              <div class="mb-3" >
                <label for="NameLabelUpdate" class="labelFount">Tipo de documento</label>
                <div class="" style="display: flex; justifyContent: center; ">
                <select class="select" id="status" style="width: 100%; height: 2.4rem; border: 0.5px solid #E0E0E0; border-radius:4px; background-color: #fff; padding: 0.5rem;">
                  <option value="2">Cedula de Ciudadania</option>
                  <option value="3">NIT</option>
                  <option value="4">Tarj de Identidad</option>
                  <option value="5">Registro Civil</option>
                  <option value="6">Ced de Extrageria</option>
                  <option value="7">Pasaporte</option>
                  <option value="8">NUIP</option>
                  <option value="9">Codigo DANE</option>
                </select>
                </div>
              </div>
                        <div class="col-12">
                            <label for="NameLabelUpdate" class="labelFount">Documento</label>
                            <input ${cedula ? 'disabled' : ''} type="number" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="` +
      cedula +
      `">
                            <div style="display: flex; align-items: center; gap: 0.35rem; flex-wrap: wrap; font-size: 0.9rem; text-align: left; margin-top: 0.6rem; margin-bottom: 0.4rem;">
                              ${warningIcon}
                              <strong>Verifica la identidad del cliente.</strong>
                              <a href="https://www.procuraduria.gov.co/Pages/consulta-de-antecedentes.aspx" target="_blank" rel="noopener noreferrer">Consulta de antecedentes</a>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount">CEL Propietario</label>
                          <input type="number" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="` +
      celular +
      `">
                      </div>
                      
                    </div>
                    <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount">Correo propietario</label>
                          <input disabled type="email" id="swal-input5" class="form-control" placeholder="Correo propietario" value="` +
      email +
      `" >
                      </div>
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                        ` +
      campoArchivo("swal-input6") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara frontal</label>
                        ` +
      campoArchivo("swal-input7") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara posterior</label>
                        ` +
      campoArchivo("swal-input8") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Plan</label>
                        <h5>` +
      props.nombreplan +
      `</h5>
                        <h5>$` +
                        valor_plan +
      `</h5>
                    </div>
    
                    <div class="row mb-4">
                      <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                      <textarea 
                        id="swal-input9" 
                        class="form-control" 
                        rows="5" 
                        placeholder="Para hacer saltos de linea presionar ENTER"
                      >${observacionesTexto}</textarea>
                    </div>
                </div>
            </form>
          `,
    confirmButtonText: "Comprar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#655CC9",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    focusConfirm: false,
    showCloseButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      ["swal-input6", "swal-input7", "swal-input8"].forEach((id) => {
        const input = document.getElementById(id);
        const nombre = document.getElementById(`${id}-nombre`);
        document.getElementById(`${id}-cargar`).addEventListener("click", () => input.click());
        input.addEventListener("change", () => {
          if (input.files[0]) nombre.textContent = input.files[0].name;
        });
      });
    },
    preConfirm: () => {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const RES = {
        name: document.getElementById("swal-input1").value,
        last_name: document.getElementById("swal-input10").value,
        dni: document.getElementById("swal-input2").value,
        phone: document.getElementById("swal-input3").value,
        password: password,
        username: document.getElementById("swal-input5").value,
        action: "UnifiedSaleUser",
      };

      var formdata = new FormData();
      formdata.append("address", adress);
      // if (phone_fijo !== null && phone_fijo !== undefined && phoneFijo.trim() !== '') {
      //   formData.append("phone_fijo", phoneFijo);
      // }
      // formdata.append("phone_fijo", phone_fijo);
      formdata.append("name", document.getElementById("swal-input1").value);
      formdata.append(
        "last_name",
        document.getElementById("swal-input10").value
      );
      formdata.append("type_ide", document.getElementById("status").value);
      formdata.append("cc", document.getElementById("swal-input2").value);
      formdata.append(
        "contact_phone",
        document.getElementById("swal-input3").value
      );

      formdata.append(
        "email_owner",
        document.getElementById("swal-input5").value
      );

      formdata.append("estrato", estrato);
      formdata.append("city_owner", CITI);
      formdata.append("price_plan", valor_plan);
      formdata.append("ad_cc", document.getElementById("swal-input7").files[0]);
      formdata.append(
        "ad_cc_back",
        document.getElementById("swal-input8").files[0]
      );
      formdata.append("category", "Residencial");
      formdata.append(
        "rec_pub",
        document.getElementById("swal-input6").files[0]
      );
      formdata.append("plan", props.nombreplan);
      formdata.append(
        "observations",
        document.getElementById("swal-input9").value
      );
      formdata.append("cdo", cdo);
      formdata.append("zone", zone);
      formdata.append("id_plan", props.id__planes);
      formdata.append("plan_type", props.tipoplan);
      formdata.append("id_plan_open", props.codigo_open);
      formdata.append(
        "user_creation",
        window.sessionStorage.getItem("idusercreationRes")
      );
      formdata.append("seller", window.sessionStorage.getItem("id"));
      formdata.append("localization", localization);

      const registrado = window.sessionStorage.getItem("Register");
      if (registrado === "No") {
        props.setLoading(true);
        return fetch(domain + "/user/register/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(RES),
        }).then(async (response) => {
            const data = await response.json(); // Convertir la respuesta a formato JSON
            if (response.status === 201) {
              // Si la solicitud fue exitosa, continuar con el flujo
              formdata.append("user_creation", data.user_creation);
        
              var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow",
              };
        
              fetch(domain + "/portal/", requestOptions)
                .then(async function (response1) {
                  if (response1.status === 201) {
                    props.setLoading(false);
                    Swal.fire({
                      title: "Registro exitoso",
                      text: "Infórmale al usuario para que active su cuenta y firme su contrato",
                      icon: "success",
                      confirmButtonColor: "#3085d6",
                      confirmButtonText: "Ver solicitud",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.href = "/Solicitud/[S,C,NA]";
                      }
                    });
                  } else {
                    if (response1.status === 400) {
                      props.setLoading(false);
                      const errorData = await response1.json();
                      Swal.showValidationMessage(`Error: ${errorData.msg || "Error desconocido"}`);
                    }
                  }
                })
                .catch((error) => {
                  console.log("error", error);
                  Swal.showValidationMessage(`Error en la solicitud: ${error.message}`);
                });
            } else {
              props.setLoading(false);
              window.sessionStorage.removeItem("credentials");
              let errorMessages = "<div style='display: flex; flex-direction: column;'>";
              errorMessages += "<ul>";

              // Recorrer los mensajes de error y agregarlos a la lista
              for (const [field, messages] of Object.entries(data.msg)) {
                errorMessages += `<li><strong>${field}:</strong> ${messages.join(", ")}</li>`;
              }

              errorMessages += "</ul>";
              errorMessages += "</div>";
              Swal.showValidationMessage(errorMessages);
            }
          }).catch((error) => {
            props.setLoading(false);
            Swal.showValidationMessage(`${error.message}`);
          });
      } else {
        props.setLoading(true);
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        // {"status":400,"type":"error","msg":"This QueryDict instance is immutable"}
        return fetch(domain + "/portal/", requestOptions)
          .then(async (response) => {
            let errorMsg = "";
            if (!response.ok) {
              // Verificar si la respuesta tiene contenido
              const responseBody = await response.text();

              try {
                props.setLoading(false);
                errorMsg = JSON.parse(responseBody);

                if (errorMsg.msg) {
                  console.log(errorMsg);
                  let htmlMessage = "<div style='display: flex; flex-direction: column;'>";
                  htmlMessage += "<ul>";
                
                  for (let key in errorMsg.msg) {
                    if (errorMsg.msg.hasOwnProperty(key)) {
                      const errorDetails = Array.isArray(errorMsg.msg[key])
                        ? errorMsg.msg[key].join(", ")
                        : errorMsg.msg[key];
                      htmlMessage += `<li><strong>${key}:</strong> ${errorDetails}</li>`;
                    }
                  }
                
                  htmlMessage += "</ul></div>";
                
                  Swal.showValidationMessage(htmlMessage);
                }
                
              } catch (error) {
                console.log(response.statusText);

                // Si hay un error al convertir a JSON o no hay propiedad 'msg', lanzar un error genérico
                throw new Error(
                  `${mess}`
                );
              }
            } else {
              props.setLoading(false);
              Swal.fire({
                title: "Registro exitoso",
                text: "Infórmale al usuario para que active su cuenta y firme su contrato",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ver solicitud",
                // timer: 4000,
              }).then((result) => {
                window.sessionStorage.removeItem("idusercreationRes");
                window.sessionStorage.removeItem("emailRes");
                window.sessionStorage.removeItem("cedulaRes");
                window.sessionStorage.removeItem("phoneRes");
                window.sessionStorage.removeItem("namedasRes");
                window.sessionStorage.removeItem("last_nameRes");
                if (result.isConfirmed) {
                  sessionStorage.getItem("groups") === "vendedor_PAP"
                    ? (window.location.href = "/Dashboardprincipal")
                    : (window.location.href = "/Solicitud/[S,C,NA]");
                }
              });
            }
          })
          .catch((error) => {
            props.setLoading(false);
            Swal.showValidationMessage(`${error.message}`);
          });
      }
    },
    });
  };

  if (isTvCard) {
    showTvCompatibilityModal(props.nombreplan, showSolicitudServicioModal);
  } else {
    showSolicitudServicioModal();
  }
};

// ## Summary
// This code defines a function named `SolicitudLoginUny` that handles the process of submitting a service request. It retrieves various data from the session storage and creates a form using SweetAlert2 library. The form includes input fields for the user to enter their personal information and attach necessary files. Upon form submission, the function sends a request to the server to register the user and create a service request. The function handles different scenarios based on the response from the server.

// ## Example Usage
// ```javascript
// import { SolicitudLoginUny } from "./path/to/file";

// // Call the function
// SolicitudLoginUny(props);
// ```

// ## Code Analysis
// ### Inputs
// - `props` (object): The props object containing necessary data for the function to work properly.
// ___
// ### Flow
// 1. Retrieve various data from the session storage such as name, last name, email, etc.
// 2. Create a form using SweetAlert2 library with pre-filled input fields.
// 3. Handle form submission:
//    - If the user is not registered, send a registration request to the server and retrieve the user creation ID.
//    - Create a FormData object and append all the necessary data to it.
//    - Send a request to the server to create a service request.
//    - Handle different scenarios based on the response from the server:
//      - If the request is successful, show a success message and redirect the user to the appropriate page.
//      - If there is an error, show an error message with the specific error details.
// ___
// ### Outputs
// - None. The function performs various actions based on the user's interaction with the form and the response from the server.
// ___
